import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

/**
 * The entry point Vite loads from `index.html`. It does one thing, and the throw is deliberate: a
 * missing `#root` means the HTML shell and this bundle disagree, and failing loudly at boot beats a
 * blank page with a clean console.
 */
const container = document.getElementById('root');
if (container === null) throw new Error('index.html ei sisalda #root elementi');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
